<script>
export default {
  props: {
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#2F54EB'
    }
  }
}
</script>
<template>
  <svg :width="size" height="auto" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g>
        <path id="Vector"
          d="M13 2H3C2.44772 2 2 2.44772 2 3V10.3333C2 10.8856 2.44772 11.3333 3 11.3333H13C13.5523 11.3333 14 10.8856 14 10.3333V3C14 2.44772 13.5523 2 13 2Z"
          :stroke="color" stroke-width="1.33333" stroke-linejoin="round" />
        <path id="Vector_2" d="M4.6665 14H11.3332" :stroke="color" stroke-width="1.33333" stroke-linecap="round"
          stroke-linejoin="round" />
        <path id="Vector_3" d="M8 11.3335V14.0002" :stroke="color" stroke-width="1.33333" stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
    </g>
  </svg>

</template>
